import React from 'react';
import CopilotResponseView from "./CopilotResponseView";
import { User, Lightbulb } from "lucide-react";
import { formatDateTimeOrNull } from "utils";

function ChatMessageView({ chat }) {
  console.log(chat);
  return (
    <div className={`flex w-full gap-3 my-4 ${chat.type === 'user' ? 'flex-row-reverse' : '' }`}>
      <div className={`p-2 h-8 w-8 flex items-center justify-center bg-text rounded-full text-white
          ${chat.type === 'user' ? 
           'bg-gradient-to-br from-emerald-500 to-teal-500' : 'bg-gradient-to-br from-emerald-500 via-green-600 to-purple-600'} 
          `}>
        {chat.type === 'user' ?
          <User />
          : <Lightbulb />
        }
      </div>
      <div className="w-[70%] ">
        <div className={`flex w-full rounded-xl pt-2 px-3 shadow-md ${chat.type === 'user' ? 'items-center justify-end bg-gradient-to-br from-emerald-500 to-teal-500 text-white' : ''}`}>
            <CopilotResponseView message={chat?.data?.message}/>
        </div>
        <p className={`text-[10px] text-muted-foreground mt-1 px-1 ${chat.type === 'user' ? 'text-right' : '' }`}>
          {formatDateTimeOrNull(chat?.data?.timestamp, 'YYYY-MM-DD hh:mm A')}
          </p>
      </div>
    </div>
  );
}

export default ChatMessageView;